import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTranslateGrade } from 'utils/customHooks/useTranslateGrade'
import { AppDispatch, RootState } from 'redux/store'
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import { Tooltip } from '@mui/material'
import { ArrowCircleDownOutlined, ArrowCircleRightOutlined, Check } from '@mui/icons-material'
import { FaPencilAlt } from 'react-icons/fa'
import { setGradePopupData } from 'redux/ui/groupCourseGradebookUI'
import { StudentAvatar } from '../student/StudentAvatar'

interface IProps {
  groupCourse: any
  courses: any[]
  students: any[]
  components: any[]
  academic_periods: any[]
}

const GroupCourseGradebookFull: FC<IProps> = ({ students, components, academic_periods }) => {
  const reduxKey = 'groupCourseGradebook';
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()
  const [translateGrade, gradeColor] = useTranslateGrade();

  const academic_year =  useSelector((state: RootState) => state[reduxKey].tableFilters.academic_year)
  const group_course =  useSelector((state: RootState) => state[reduxKey].tableFilters.group_course)
  
  const [openRow, setOpenRow] = useState(null)
  

  return (
    <>
      <div className='gradebook-grid-wrapper'>
          <table className='gradebook-grid gradebook-grid-full' style={{ minWidth: `${ 660+academic_periods.length*505 }px` }}>
            <tbody>
            <tr>
              <td style={{ width: '200px', textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>
                {t('common.students')}
              </td>
              <td style={{ width: '100px', textAlign: 'center' }}>
                {t('common.accommodations-short')}
              </td>
              <td style={{ width: '100px', textAlign: 'center' }}>
                {t('common.modifications-short')}
              </td>
              <td style={{ width: '100px', fontWeight: '600', fontSize: '14px', textAlign: 'center', position: 'relative' }} className='gradebook-grid-orange'>
                <Tooltip title={t('common.real-time-calculation')} placement='top'>
                    <div>
                      {t('common.overall')}
                      <div className="gradebook-grid-hint">{t('common.calculated')}*</div>
                    </div>
                </Tooltip>
              </td>
              <td colSpan={2}  className='gradebook-grid-dark-blue'
                style={{ width: '160px', textTransform: 'uppercase', textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>
                {t('common.final-grade')}
              </td>
              {academic_periods.map(term => <React.Fragment key={`${term.id}`}>
              <td key={`${term.id}-1-1`} colSpan={2} style={{ width: '350px', paddingLeft: '20px', fontSize: '16px', fontWeight: '600' }} 
                   className='gradebook-grid-blue'>
                  {term.title}
              </td>
              <td key={`${term.id}-2`}  colSpan={2} style={{ width: '100px', fontWeight: '600', fontSize: '12px' }} 
                className='gradebook-grid-blue'>
                  <div style={{ fontSize: '12px', lineHeight: '14px'}}>{term.title}<br />{t('common.final-grade')}</div>
              </td>
              <td rowSpan={2 + students.length + components.length} style={{width:'4px',padding: '0px'}}></td>
              </React.Fragment>)}
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td className='gradebook-grid-orange'></td>
              <td style={{ width: '80px', fontSize: '10px', textAlign: 'center' }} className='gradebook-grid-dark-blue'>{t('common.not-published')}</td>
              <td style={{ width: '80px', fontSize: '10px', textAlign: 'center' }} className='gradebook-grid-dark-blue'>{t('common.published')}</td>
              {academic_periods.map(term => <React.Fragment key={`${term.id}`}>
                <td style={{ width: '80px', fontSize: '10px' }} className='gradebook-grid-light-blue'>
                  <Tooltip title={t('common.pre-assessment-grade')} placement='top'>
                   <span>{t('common.entry-level')}</span>
                  </Tooltip>
                </td>
                <td style={{ width: '250px', fontSize: '10px' }} className='gradebook-grid-light-blue'>{t('common.current')}</td>
                <td style={{ width: '80px', fontSize: '10px' }} className='gradebook-grid-light-blue'>{t('common.not-published')}</td>
                <td style={{ width: '80px', fontSize: '10px' }} className='gradebook-grid-light-blue'>{t('common.published')}</td>
              </React.Fragment>)}
            </tr>

            {students.map( (s, sIdx) => <React.Fragment key={`${s.id}`}>
              <tr className={`gradebook-main-row ${sIdx%2==0 ? 'odd' : 'even'}`}>
                <td style={{ paddingTop: '8px', paddingBottom: '8px' }}>
                  
                  <div 
                    onClick={() => {
                      if(openRow == s.id)
                        setOpenRow(null)
                      else
                        setOpenRow(s.id)
                    }}
                    style={{ display: 'flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }}>
                    {openRow == s.id 
                      ? <ArrowCircleDownOutlined sx={{ color: '#63b9ff' }} /> 
                      : <ArrowCircleRightOutlined sx={{ color: '#63b9ff' }} /> }
                    <span>
                        <StudentAvatar avatar={s.avatar} name={s.display_name} />
                    </span>
                  </div>
                </td>
                <td>
                  {s.accommodations && s.accommodations.length > 0 && <div style={{ textAlign: 'center'}}>
                    <Tooltip title={s.accommodations.join(', ')} placement='top'><Check /></Tooltip>
                  </div>}
                </td>
                <td>
                  {s.modifications.length > 0 && <div style={{ textAlign: 'center'}}>
                    <Tooltip title={s.modifications.join(', ')} placement='top'><Check /></Tooltip>
                  </div>}
                </td>

                <td style={{ textAlign: 'center' }}>
                  {s.calculated_grade_percentage ? `${s.calculated_grade_percentage}%` : ''}
                </td>
                <td className='gradebook-grid-dark-blue'  style={{ textAlign: 'center', fontSize: '16px' }}>
                   {(s.final_grade_percentage === null) 
                    ? <span style={{ cursor: 'pointer' }} onClick={()=>{
                         dispatch(setGradePopupData({
                          type: 'final',
                          group_course_id: group_course,
                          student_id: s.id,
                          student_name: s.display_name,
                          academic_year: academic_year,
                          grade_percentage: s.calculated_grade_percentage,
                         }))
                        }}>
                        {translateGrade(s.calculated_grade_percentage)}
                        <FaPencilAlt style={{ fontSize: '14px', color: '#000', marginLeft: '5px' }}/>
                    </span> : ''}
                </td>
                <td className='gradebook-grid-dark-blue'  style={{ textAlign: 'center' }}>
                  {s.final_grade_percentage !== null ? 
                      <span className="grading-circle" 
                        style={{ background: gradeColor(s.final_grade_percentage) }}>
                          {translateGrade(s.final_grade_percentage)}
                      </span>
                       : ''}
                </td>

                {academic_periods.map(term => { 
                  
                  const academicPeriod = s.academic_periods?.find(ap => ap.id == term.id) ?? null
                  
                  return <React.Fragment key={`${term.id}`}>
                  <td>
                      <div style={{ display: 'flex', gap: '10px', fontSize: '16px', paddingLeft: '10px' }}>
                      {academicPeriod && academicPeriod.entry_assignments.length > 0  && 
                        academicPeriod.entry_assignments.map(a => <Tooltip key={a.assessment_id} 
                          title={a.assignment_title} placement='top'>
                            <span>{translateGrade(a.grade_percentage)}</span>
                        </Tooltip>)}
                      </div>
                  </td>
                  <td>
                     <div style={{ display: 'flex', gap: '10px', fontSize: '16px' }}>
                      {academicPeriod && academicPeriod.regular_assignments.length > 0  && 
                        academicPeriod.regular_assignments.map(a => <Tooltip key={a.assessment_id} 
                          title={a.assignment_title} placement='top'>
                            <span>{translateGrade(a.grade_percentage)}</span>
                        </Tooltip>)}
                      </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                   {(academicPeriod.final_grade_percentage === null) 
                    ? <span style={{ cursor: 'pointer', fontSize: '16px'  }} onClick={()=>{
                        dispatch(setGradePopupData({
                          type: 'term',
                          group_course_id: group_course,
                          student_id: s.id,
                          student_name: s.display_name,
                          academic_year: academic_year,
                          academic_period_id: term.id,
                          academic_period_title: term.title,
                          grade_percentage: s.calculated_grade_percentage,
                        }))
                        }}>
                        {translateGrade(academicPeriod.calculated_grade_percentage)}
                        <FaPencilAlt style={{ fontSize: '14px', color: '#000', marginLeft: '5px' }}/>
                    </span> : ''}
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {academicPeriod.final_grade_percentage !== null ? 
                      <span className="grading-circle" 
                        style={{ background: gradeColor(academicPeriod.final_grade_percentage) }}>
                          {translateGrade(academicPeriod.final_grade_percentage)}
                      </span>
                       : ''}
                  </td>
                  </React.Fragment>})}
              </tr>

              {openRow == s.id && components.map( (c,idx) => {
                
                return <tr key={`sr-${s.id}-${c.id}`} className={`gradebook-grid-subrow ${idx%2==0 ? 'odd' : 'even'}`}>
                  <td colSpan={3}>{c.title}</td>
                  <td style={{textAlign: 'center'}}>{c.importance}</td>
                  <td colSpan={2}></td>

                  {
                      academic_periods.map(term => { 
                    
                        const academicPeriod = s.academic_periods?.find(ap => ap.id == term.id) ?? null
                      
                        return <React.Fragment key={`sr-${s.id}-${c.id}-${term.id}`}>
                          <td>
                              <div style={{ display: 'flex', gap: '10px', fontSize: '16px', paddingLeft: '10px' }}>
                              {academicPeriod && academicPeriod.entry_assignments.length > 0  && 
                                academicPeriod.entry_assignments.filter(a => a.component_id == c.id).map(a => 
                                <Tooltip key={a.assessment_id} 
                                  title={a.assignment_title} placement='top'>
                                    <span>{translateGrade(a.grade_percentage)}</span>
                                </Tooltip>)}
                              </div>
                          </td>
                          <td key={`${s.id}-${c.id}-2`}>
                            <div style={{ display: 'flex', gap: '10px', fontSize: '16px' }}>
                              {academicPeriod && academicPeriod.regular_assignments.length > 0  && 
                                academicPeriod.regular_assignments.filter(a => a.component_id == c.id).map(a => 
                                <Tooltip key={a.assessment_id} 
                                  title={a.assignment_title} placement='top'>
                                    <span>{translateGrade(a.grade_percentage)}</span>
                                </Tooltip>)}
                              </div>
                          </td>
                          <td colSpan={2}></td>
                          </React.Fragment>   
                      }) 
                    }

                  
              </tr>})}

              </React.Fragment>        
            )}
            </tbody>
          </table>
        </div>   
    </>
  )
}
export default GroupCourseGradebookFull
